import { initializeApp } from "firebase/app";
import { deleteToken, getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase web app config (from Firebase console)
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APP_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

const isFirebaseConfigValid = !!(
    firebaseConfig.apiKey &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId
);

// Initialize Firebase & Messaging service conditionally
let app = null;
let messaging = null;

if (isFirebaseConfigValid) {
    try {
        app = initializeApp(firebaseConfig);
        messaging = getMessaging(app);
    } catch (error) {
        console.error("❌ Error initializing Firebase:", error);
    }
} else {
    console.warn("⚠️ Firebase configuration is missing or incomplete. Push notifications will be disabled.");
}

// 👇 This function requests and returns the FCM token
export const requestForToken = async () => {
    if (!messaging) {
        console.warn("⚠️ requestForToken: Firebase messaging is not initialized.");
        return null;
    }
    try {
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, // from Firebase Cloud Messaging > Web Push Certificates
        });

        console.log({ token });

        if (token) {
            return token;
        } else {
            return null;
        }
    } catch (err) {
        console.error("❌ Error retrieving FCM token:", err);
        return null;
    }
};

const unregisterFCM = async () => {
    if (!messaging) return;
    try {
        const currentToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY });

        if (currentToken) {
            await deleteToken(messaging);

            const swReg = await navigator.serviceWorker.getRegistration();
            if (swReg) {
                await swReg.unregister();
            }
        }
    } catch (err) {
        console.error("❌ Error unregistering FCM:", err);
    }
};

// Also export messaging + onMessage so other components can listen for pushes
export { messaging, onMessage, unregisterFCM };
